import Big, { BigSource } from 'big.js';

export const countProgress = (currentAmount: BigSource, supposedAmount: BigSource): number | null =>
  supposedAmount?.toString() !== '0'
    ? currentAmount && supposedAmount ? Number((new Big(currentAmount).times(100)).div(supposedAmount).toFixed(1)) : null
    : null;
